// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'phone',
})
export class PhonePipe implements PipeTransform {
    transform(phone: any) {
        if (phone.startsWith('+1') && phone.length === 12) {
            const areaCode = phone.slice(2, 5);
            const prefix = phone.slice(5, 8);
            const digits = phone.slice(8, 12);

            return `${areaCode}-${prefix}-${digits}`;
        }

        return phone;
    }
}
